<p-multiSelect
  [options]="options"
  [(ngModel)]="selectedOptions"
  (onChange)="onChangeEvent($event)"
  optionLabel="label"
  optionDisabled="optionDisabled"
  [placeholder]="placeholder"
  [selectedItemsLabel]="selectedItemsLabel"
  dataKey="id"
  [maxSelectedLabels]="maxSelectedLabels"
  [filter]="filter"
  [filterValue]="filterValue"
  [disabled]="formDisabled"
  [required]="required"
  appendTo="body"
>
  <ng-template pTemplate="item" let-option>
    <span class="flex-1">{{ option.label }}</span>
    <i *ngIf="editable" class="pi pi-pencil edit-option" title="Modifier" (click)="editOption($event, option)"></i>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      *ngIf="editable"
      type="button"
      pButton
      icon="pi pi-plus"
      label="Nouveau"
      class="p-button-text p-button-sm"
      (click)="editOption($event)"
    ></button>
  </ng-template>
</p-multiSelect>
